import { useMemo } from 'react';
import { useRouter } from 'next/router';

import { SEARCH_QUERY_GENERIC } from '../consts';

const useCountyCityZone = () => {
  const router = useRouter();

  const routerQuery = useMemo(
    () => (router.query.query ? router.query.query : ''),
    [router.query.query]
  );
  const [county, city, zone] = useMemo(() => {
    let [county, city, zone] = (routerQuery as string)
      .split('--')
      .map((part) => (part === SEARCH_QUERY_GENERIC ? undefined : part));
    if (router.query.county) {
      county = router.query.county as string;
    }
    if (router.query.city) {
      city = router.query.city as string;
    }
    if (router.query.zone) {
      zone = router.query.zone as string;
    }
    return [county, city, zone];
  }, [router.query, routerQuery]);

  return [county || undefined, city, zone];
};

export default useCountyCityZone;
